import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  folders: null,
  customerDirectory: null,
  currentDirectory: null,
  downloadFile: {},
  uploadFile: {},
  archivedFile: {},
  restoredFile: {},
  deleteFile: {},
  duplicateFile: {},
  fileProperties: {},
  renameFile: {},
  folderProperties: {},
  archivedFolder: {},
  restoredFolder: {},
  recyclingBin: [],
  deleteFolder: {},
  duplicateFolder: {},
  renameFolder: {},
  togglecreateFolder: false,
  toggleUploadFile: false,
  toggleShowProperties: false,
  toggleRecyclinBin: false,
  toggleRecyclingBin: false,
  toggleRenameFolder: false,
  toggleRenameFile: false,
  toggleRestoreItem: false,
  toggleDeleteArchiveItem: false,
  toggleEditDiagram: false,
  newFolder: {},
  currentPath: '',
  folderPropertiesToggle: false,
  propertiesToggle: false,
  selectedArchiveItem: {},
  deleteItemFromRecyclebin: {},
  filePreview: [],
  isLoading: false,
  error: [],
  toggleModal: false,
};

const sharepointSlice = createSlice({
  name: 'sharepoint',
  initialState,
  reducers: {
    start: (state, action) => {
      state.isLoading = true;
      state.error = [];
    },
    resetFilePropertiesStart: (state) => {
      state.fileProperties = {};
      state.isLoading = true;
      state.error = [];
    },
    getCurrentFolderItemsStart: (state, action) => {
      state.currentDirectory = [];
      state.isLoading = true;
      state.error = [];
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
    },
    setDiagramsDirectory: (state, action) => {
      state.diagramsDirectory = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setResetFilePreview: (state, action) => {
      state.isLoading = false;
      state.filePreview = [];
    },
    setToggleRenameFolder: (state, action) => {
      state.toggleRenameFolder = action.payload;
    },
    setCurrentFolderPath: (state, action) => {
      state.currentPath = action.payload;
      state.isLoading = false;
    },
    setNewFolder: (state, action) => {
      state.newFolder = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setToggleCreateFolder: (state, action) => {
      state.togglecreateFolder = action.payload;
    },
    setCustomerFolder: (state, action) => {
      state.folders = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCustomerDirectory: (state, action) => {
      state.customerDirectory = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCurrentDirectory: (state, action) => {
      state.currentDirectory = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setDownloadFile: (state, action) => {
      state.downloadFile = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setUploadFile: (state, action) => {
      state.uploadFile = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setToggleUploadFile: (state, action) => {
      state.toggleUploadFile = action.payload;
    },
    setArchivedFile: (state, action) => {
      state.archivedFile = action.payload;
      state.error = [];
    },
    setRestoredFile: (state, action) => {
      state.restoredFile = action.payload;
      state.error = [];
    },
    setToggleRestoreItem: (state, action) => {
      state.toggleRestoreItem = action.payload;
    },
    setDeleteFile: (state, action) => {
      state.deleteFile = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setDuplicateFile: (state, action) => {
      state.duplicateFile = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setFileProperties: (state, action) => {
      state.fileProperties = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setRecyclingBin: (state, action) => {
      state.recyclingBin = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setToggleRecyclingBin: (state, action) => {
      state.toggleRecyclingBin = action.payload;
    },
    setSelectedArchiveItem: (state, action) => {
      state.selectedArchiveItem = action.payload;
      state.isLoading = false;
    },
    setToggleDeleteArchiveItem: (state, action) => {
      state.toggleDeleteArchiveItem = action.payload;
    },
    setToggleRenameFile: (state, action) => {
      state.toggleRenameFile = action.payload;
    },
    setFolderProperties: (state, action) => {
      state.folderProperties = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setToggleShowProperties: (state, action) => {
      state.toggleShowProperties = action.payload;
    },
    setArchivedFolder: (state, action) => {
      state.archivedFolder = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setRestoredFolder: (state, action) => {
      state.restoredFolder = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setDeleteFolder: (state, action) => {
      state.deleteFolder = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setDeleteItemFromRecyclebin: (state, action) => {
      state.deleteItemFromRecyclebin = action.payload;
      state.error = [];
    },
    setDuplicateFolder: (state, action) => {
      state.duplicateFolder = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setRenameFolder: (state, action) => {
      state.renameFolder = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setFolderPropertiesToggle: (state, action) => {
      state.folderPropertiesToggle = action.payload;
      state.isLoading = false;
    },
    setPropertiesToggle: (state, action) => {
      state.propertiesToggle = action.payload;
      state.isLoading = false;
    },
    setFilePreview: (state, action) => {
      state.filePreview = [...state.filePreview, action.payload];
      state.error = [];
    },
    setResetSharepoint: () => {
      return initialState;
    },
  },
});

export const {
  start,
  resetFilePropertiesStart,
  getCurrentFolderItemsStart,
  setReducerError,
  setPropertiesToggle,
  setDiagramsDirectory,
  setResetFilePreview,
  setToggleRenameFolder,
  setCurrentFolderPath,
  setNewFolder,
  setToggleCreateFolder,
  setCustomerFolder,
  setCustomerDirectory,
  setCurrentDirectory,
  setDownloadFile,
  setUploadFile,
  setToggleUploadFile,
  setArchivedFile,
  setRestoredFile,
  setToggleRestoreItem,
  setDeleteFile,
  setDuplicateFile,
  setFileProperties,
  setRecyclingBin,
  setToggleRecyclingBin,
  setSelectedArchiveItem,
  setToggleDeleteArchiveItem,
  setToggleRenameFile,
  setFolderProperties,
  setToggleShowProperties,
  setArchivedFolder,
  setRestoredFolder,
  setDeleteFolder,
  setDuplicateFolder,
  setRenameFolder,
  setFolderPropertiesToggle,
  setDeleteItemFromRecyclebin,
  setFilePreview,
  setResetSharepoint,
} = sharepointSlice.actions;

export default sharepointSlice.reducer;
